import { AppState } from "@store";
import { FetchingState } from "rd-redux-http";

export function isReportingOnlyCustomer(state: AppState): boolean {
    const customerData = FetchingState.getDataOrDefault(state.pagesState.customer, undefined);

    if (customerData) {
        return customerData.customer.pricing === "fixed-price";
    }

    return true;
}
